import React, { useEffect, useState } from 'react'
import {Grid, Box, Paper, Typography, Container, Button, Stack, Avatar, 
    Select, MenuItem,
    RadioGroup, FormControl, FormLabel, FormControlLabel, Radio,
    TextField, 
    TableRow, TableCell,
    IconButton
} from '@mui/material'
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { List, ListItem, ListItemText, ListItemButton, CircularProgress } from '@mui/material';
import Api from '../Services/Api';
import StaticVar from '../Config/StaticVar';
import Dialog from '../Components/Dialog'
import DataTable from '../Components/DataTable'
import CancelIcon from '@mui/icons-material/Cancel';

import groupBy from 'lodash/groupBy';
import meanBy from 'lodash/meanBy';
import mapValues from 'lodash/mapValues';
import orderBy from 'lodash/orderBy'
import { jwtDecode } from 'jwt-decode';


// 🔧 Fungsi untuk membuat summary nilai peserta
const summarizeAssessmentData = (data) => {
  // Group by kombinasi FULL_NAME + DOJO_NAME
  const groupedByParticipant = groupBy(data, item => `${item.FULL_NAME}|${item.DOJO_NAME}`);

  const result = Object.entries(groupedByParticipant).map(([key, groupItems]) => {
    const [FULL_NAME, DOJO_NAME] = key.split('|');

    // Group berdasarkan parent assessment ID (ASS-01, ASS-02, dst)
    const scoresByParent = groupBy(groupItems, 'PARENT_ID');

    // Hitung total skor per grup PARENT_ID
    const parentScores = mapValues(scoresByParent, items => Number(meanBy(items, item => Number(item.SCORE)).toFixed(2)));

    // Hitung total semua skor
    const totalScore = Object.values(parentScores).reduce((a, b) => a + b, 0);

    return {
      FULL_NAME,
      DOJO_NAME,
      "KIHON": parentScores["ASS-01"] || 0,
      "KATA": parentScores["ASS-02"] || 0,
      "KUMITE": parentScores["ASS-03"] || 0, // akan 0 jika tidak ada
      TOTAL: totalScore,
    };
  });

  return result;
};

const calculateTotalAssessmentProgress = (data) => {
  const total = data.length;
  const done = data.filter(item => Number(item.SCORE) > 0).length;

  const percentage = total > 0 ? ((done / total) * 100).toFixed(2) : "0.00";
  return `${percentage}%`;
};

function AssesmentListData({data, changeAssesment}){
    return(
        <List>
            {data.map((item, index) => (
                <Paper
                key={index}
                elevation={2}
                sx={{
                    mb: 1,
                    borderRadius: 1,
                    overflow: 'hidden',
                    transition: 'transform 0.2s ease, background-color 0.2s ease',
                    '&:hover': {
                    transform: 'scale(1.03)', // Zoom effect
                    },
                }}
                >
                <ListItemButton
                    onClick={()=>changeAssesment(item)}
                    sx={{
                    backgroundColor: item.STATUS_EXAM,
                    transition: 'background-color 0.3s',
                    '&:hover': {
                        backgroundColor: '#e0e0e0', // Hover warna seragam (abu terang)
                    },
                    }}
                >
                    <ListItemText primary={item.ASSESMENT_NAME} />
                </ListItemButton>
                </Paper>
            ))}
        </List>
    )
}

function AssesmentListTabs({data, changeAssesment}) {
  const [value, setValue] = React.useState('1');
  const kihonData = data.filter(x=>x.PARENT_ID==='ASS-01')
  const kataData = data.filter(x=>x.PARENT_ID==='ASS-02')
  const kumiteData = data.filter(x=>x.PARENT_ID==='ASS-03')
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example" variant="scrollable" scrollButtons="auto">
            <Tab label="KIHON" value="1" />
            <Tab label="KATA" value="2" />
            <Tab label="KUMITE" value="3" />
          </TabList>
        </Box>
        <TabPanel value="1" sx={{p:0}}>
            <AssesmentListData data={kihonData} changeAssesment={changeAssesment}/>

        </TabPanel>
        <TabPanel value="2" sx={{p:0}}>
            <AssesmentListData data={kataData} changeAssesment={changeAssesment}/>
        </TabPanel>
        <TabPanel value="3" sx={{p:0}}>
            <AssesmentListData data={kumiteData} changeAssesment={changeAssesment}/>
        </TabPanel>
      </TabContext>
    </Box>
  );
}

function HeaderPage({eventData, groupData, chooseGroup, changeGroup, evaluatorName}){
    
    return(
        <Stack spacing={2} direction="row" sx={{
            justifyContent: "space-between",
            alignItems: "center",
        }}>
            <Stack direction="column">
                <Box sx={{ display: { xs: 'none', sm: 'none', md: 'block', lg: 'block', xl: 'block'  } }}><Typography variant='h6'>Panel Assesment Examination</Typography></Box>
                <Typography>{eventData.EVENT_NAME}</Typography>
                Penguji : {evaluatorName}
            </Stack>
            
            <Stack spacing={1} direction="row" sx={{
                justifyContent: "flex-end",
                alignItems: "center",
            }}>
                <Box sx={{ display: { xs: 'none', sm: 'none', md: 'block', lg: 'block', xl: 'block'  } }}>
                    <Typography>Find Data By : </Typography>
                </Box>
                <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={chooseGroup}
                    onChange={changeGroup}
                >
                    <MenuItem value="0">
                    <em>Pilih Group</em>
                    </MenuItem>
                    {
                        groupData.map(item=>{
                            return(
                                <MenuItem value={item.GROUP_ID}>
                                    <em>Group - {item.GROUP_ID}</em>
                                </MenuItem>
                            )
                        })
                    }
                </Select>
                <Button variant='contained' color='error' onClick={()=>{localStorage.clear();window.location.href = '/app/login';} }>Logout</Button>
            </Stack>
        </Stack>
    )
}

export default function HomePage() {
  const [score, setScore] = React.useState(0);

  const [openModalResult, setOpenModalResult] = useState(false)
  const [openModalPublish, setOpenModalPublish] = useState(false);

  const handleChangeScore = (value, item) => {
    const changeScoreParticipant = participants.map(itemparticipant=>{
        if(itemparticipant.PARTICIPANT_ID === item.PARTICIPANT_ID && itemparticipant.ASSESMENT_ID === item.ASSESMENT_ID){
            return {...itemparticipant, SCORE : Number(value)}
        }
        else{
            return itemparticipant
        }
    }) 
    setParticipants(changeScoreParticipant)
    setScore(value);
  };

  const [assesments, setAssesments] = useState([]);
  const [eventData, setEventData] = useState({});
  const [groups, setGroups] = useState([]);
  const [participants, setParticipants] = useState([])
  const [participantAllAsssesment, setParticipantAllAssesment] = useState([])
  const [chooseGroup, setChooseGroup] = useState("0")
  const [chooseAssesment, setChooseAssesment] = useState({})
  const [eventID, setEventID] = useState("")
  const [evaluatorID, setEvaluatorID] = useState("")
  const [evaluatorName, setEvaluatorName ] = useState("")
  
  const fetchData = async()=>{
    let decoded;
    if(localStorage.token){
        decoded = jwtDecode(localStorage.token)
        console.log('decoded', decoded)

        // Cek apakah token sudah expired
        const currentTime = Date.now() / 1000; // dalam detik
        if (decoded.exp < currentTime) {
        // Token expired
        console.warn('Token expired, redirecting...');
        localStorage.removeItem('token'); // hapus token
        window.location.href = '/app/login'; // redirect ke login
        }
    }
    else{
        window.location.href = '/app/login'; // redirect ke login
    }
    

    setEventID(decoded.EVENT_ID)
    setEvaluatorID(decoded.EVALUATOR_ID)

    const _evaluator = await Api.getEvaluator(decoded.EVALUATOR_ID)
    console.log('_evaluator', _evaluator)
    setEvaluatorName(_evaluator.FIRST_NAME+' '+_evaluator.LAST_NAME)
    
    const _event = await Api.getEvent(decoded.EVENT_ID)
    setEventData(_event)

    const _groups = await Api.getGroupList(decoded.EVENT_ID, decoded.EVALUATOR_ID)
    console.log('_groups', _groups)
    setGroups(_groups)
  }
  useEffect(()=>{
    fetchData()
  },[])


  const getParticipantList = async(group_id, assesment_id)=>{
    const _participant = await Api.getParticipantList(eventID, evaluatorID, group_id)
    setParticipantAllAssesment(_participant)
    setParticipants(_participant.filter(x=>x.ASSESMENT_ID === assesment_id))
  }

  const getParticipantAssesmentList = async(assesment_id)=>{
    const _participant = participantAllAsssesment.filter(x=>x.ASSESMENT_ID === assesment_id)
    setParticipants(_participant)
  }

  const getAssesment = async(group_id)=>{
    const _assesment = await Api.getAssesment(eventID, evaluatorID, group_id)
    setAssesments(_assesment)
    return _assesment[0]
  }

  const changeGroup = async(event)=>{
    setChooseGroup(event.target.value)
    const firstAssesment = await getAssesment(event.target.value)
    setChooseAssesment(firstAssesment)
    await getParticipantList(event.target.value, firstAssesment.ASSESMENT_ID)
  }

  const changeAssesment = (item) => {
        setChooseAssesment(item)
        getParticipantAssesmentList(item.ASSESMENT_ID)
  };

  const backAssesment = () =>{
    console.log('data assesment', assesments)
    console.log('choose assesment', chooseAssesment)
    let backNumberAssesment =  {}
    if((chooseAssesment?.ASSESMENT_NUMBER || 0) > 1  ) {
        backNumberAssesment = assesments.filter(x=>x.ASSESMENT_NUMBER === (chooseAssesment?.ASSESMENT_NUMBER-1))[0]
        console.log('backNumberAssesment', backNumberAssesment)
        changeAssesment(backNumberAssesment)
    }
    else{
        alert(`Anda mengklik penilaian pertama`);
    }
  }

  const nextAssesment = () =>{
    console.log('data assesment', assesments)
    console.log('choose assesment', chooseAssesment)
    let backNumberAssesment =  {}
    if((chooseAssesment?.ASSESMENT_NUMBER || 0) < (assesments.length)  ) {
        backNumberAssesment = assesments.filter(x=>x.ASSESMENT_NUMBER === (chooseAssesment?.ASSESMENT_NUMBER+1))[0]
        console.log('backNumberAssesment', backNumberAssesment)
        changeAssesment(backNumberAssesment)
    }
    else{
        alert(`Anda mengklik penilaian terakhir`);
    }
  }

  const handleClickOpenModalResult = ()=>{
    setOpenModalResult(true)
  }

  const handleCloseModalResult = () => {
    setOpenModalResult(false)
  }

  const handleClickOpenModalPublish = ()=>{
    setOpenModalPublish(true)
  }

  const handleCloseModalPublish = () => {
    setOpenModalPublish(false)
  }

  return (
    <Container maxWidth="xl"  sx={{p:1}}>
        <Dialog 
            title="Info Result Assesment" 
            maxWidth={"md"}
            fullWidth={true}
            open={openModalResult} 
            handleClickOpen={handleClickOpenModalResult}
            handleClose={handleCloseModalResult}>
                <DataTable headers={[
                    {name : "NO", align:'center',width:10},
                    {name : "FULL NAME", align:'left'},
                    {name : "DOJO NAME", align:'center', width:100},
                    {name : "KIHON", align:'center', width:80},
                    {name : "KATA", align:'center', width:80},
                    {name : "KUMITE", align:'center', width:80},
                ]}> 
                    {summarizeAssessmentData(participantAllAsssesment).map((row, index) => (
                        <TableRow
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                        <TableCell align="center" component="th" scope="row">
                            {index+1}
                        </TableCell>
                        <TableCell component="th" scope="row">
                            {row.FULL_NAME}
                        </TableCell>
                        <TableCell align="center">{row.DOJO_NAME}</TableCell>
                        <TableCell align="center">{row.KIHON}</TableCell>
                        <TableCell align="center">{row.KATA}</TableCell>
                        <TableCell align="center">{row.KUMITE}</TableCell>
                        </TableRow>
                    ))}
                </DataTable>
        </Dialog>

        <Dialog 
            title="Sedang mengirimkan Hasil Penilaian" 
            maxWidth={"sm"}
            fullWidth={true}
            open={openModalPublish} 
            handleClickOpen={handleClickOpenModalPublish}
            handleClose={handleCloseModalPublish}>
                <center>
                    <CircularProgress />
                    <Typography sx={{ mt: 2 }}>Menyimpan data, mohon tunggu...</Typography>
                </center>
        </Dialog>
        <Paper elevation={3} sx={{p:2}}>
            <HeaderPage 
                evaluatorName = {evaluatorName}
                eventData={eventData} 
                groupData ={groups} 
                chooseGroup={chooseGroup}
                changeGroup={changeGroup}
                />
            <Grid container sx={{mt:2, mb:2}} spacing={2}>
                <Grid item size={{xs:4,sm:4,md:4,lg:3,xl:3}}>
                    <Paper elevation={3} sx={{p:1,mb:1}}>
                        <AssesmentListTabs data={assesments} chooseAssesment={chooseAssesment} changeAssesment={changeAssesment} />
                    </Paper>
                    {/* <Paper elevation={3} sx={{p:1,mb:1}}>
                        <Typography variant='span'>Legend Data</Typography>
                        
                    </Paper> */}
                    <Paper elevation={3} sx={{p:1,mb:1}}>
                        <Box sx={{ display: {xs:"block", sm:"block", md:"none", lg:"none", xl:"none"} }}>
                            <Box style={{textAlign:'center'}}>
                                <Typography variant='h4'>progress</Typography>
                                <Typography variant='h4'>{calculateTotalAssessmentProgress(participantAllAsssesment)}</Typography>
                            </Box>
                            <Box>
                                <Button variant='contained' color="primary" size="small" sx={{width:'100%',mb:1}} onClick={handleClickOpenModalResult}>View Result</Button>
                                <Button variant='contained' color="primary" size="small" sx={{width:'100%'}} onClick={async()=>{
                                    handleClickOpenModalPublish()
                                    const dataPost = participantAllAsssesment.map(x=>{
                                        const assesmentStatus = assesments.filter(_ass => _ass.ASSESMENT_ID === x.ASSESMENT_ID)
                                        if(assesmentStatus.length>0){
                                            return {EVENT_ID: x.EVENT_ID, ASSESMENT_ID: x.ASSESMENT_ID, PARTICIPANT_ID: x.PARTICIPANT_ID, SCORE: x.SCORE, STATUS: assesmentStatus[0].STATUS_EXAM}
                                        }
                                        else{
                                            return {EVENT_ID: x.EVENT_ID, ASSESMENT_ID: x.ASSESMENT_ID, PARTICIPANT_ID: x.PARTICIPANT_ID, SCORE: x.SCORE}
                                        }
                                    })
                                    console.log('dataPost', dataPost)
                                    await Api.postAssesment(dataPost)
                                    handleCloseModalPublish()
                                }}>Publish Score</Button>
                            </Box>
                        </Box>
                        <Box sx={{ display: {xs:"none", sm:"none", md:"block", lg:"block", xl:"block"} }}>
                            <Stack direction="row" sx={{
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}>
                                <Box style={{width:'50%', textAlign:'center'}}>
                                    <Typography variant='h4'>progress</Typography>
                                    <Typography variant='h4'>{calculateTotalAssessmentProgress(participantAllAsssesment)}</Typography>
                                </Box>
                                <Box style={{width:'40%'}}>
                                    <Button variant='contained' color="primary" size="small" sx={{width:'100%',mb:1}} onClick={handleClickOpenModalResult}>View Result</Button>
                                    <Button variant='contained' color="primary" size="small" sx={{width:'100%'}} onClick={async()=>{
                                        handleClickOpenModalPublish()
                                        const dataPost = participantAllAsssesment.map(x=>{
                                            const assesmentStatus = assesments.filter(_ass => _ass.ASSESMENT_ID === x.ASSESMENT_ID)
                                            if(assesmentStatus.length>0){
                                                return {EVENT_ID: x.EVENT_ID, ASSESMENT_ID: x.ASSESMENT_ID, PARTICIPANT_ID: x.PARTICIPANT_ID, SCORE: x.SCORE, STATUS: assesmentStatus[0].STATUS_EXAM}
                                            }
                                            else{
                                                return {EVENT_ID: x.EVENT_ID, ASSESMENT_ID: x.ASSESMENT_ID, PARTICIPANT_ID: x.PARTICIPANT_ID, SCORE: x.SCORE}
                                            }
                                        })
                                        console.log('dataPost', dataPost)
                                        await Api.postAssesment(dataPost)
                                        handleCloseModalPublish()
                                    }}>Publish Score</Button>
                                </Box>
                                
                            </Stack>
                        </Box>
                        
                        
                    </Paper>
                </Grid>
                <Grid item size={{xs:8,sm:8,md:8,lg:9,xl:9}}>
                    <Paper elevation={3} sx={{p:1}}>
                        <Box
                            sx={{
                                border: '2px solidrgb(188, 206, 224)',
                                borderRadius: 3,
                                p: 2,
                                boxShadow: 3,
                                backgroundColor: '#f5faff',
                                mt: 1,
                                mb: 1,
                            }}
                            >
                            <Stack direction="row" alignItems="center" justifyContent="space-between">
                                <Button variant="outlined" color="primary" onClick={()=>backAssesment()}>
                                Back
                                </Button>
                                <Box sx={{ display: {xs:"none", sm:"none", md:"block", lg:"block", xl:"block"} }}>
                                    <Typography variant="h4" textAlign="center" sx={{ flexGrow: 1 }}>
                                    {chooseAssesment.ASSESMENT_NAME}
                                    </Typography>
                                </Box>
                                <Box sx={{ display: {xs:"block", sm:"block", md:"none", lg:"none", xl:"none"} }}>
                                    <Typography variant="h6" textAlign="center" sx={{ flexGrow: 1 }}>
                                    {chooseAssesment.ASSESMENT_NAME}
                                    </Typography>
                                </Box>
                                

                                <Button variant="outlined" color="primary" onClick={()=>nextAssesment()}>
                                Next
                                </Button>
                            </Stack>
                        </Box>
                        <Button variant="contained" color="primary" sx={{width:'100%', mb:1}} onClick={()=>{
                            
                            const _allData = participantAllAsssesment.map(x=>{
                                const checkList = participants.filter(itemparticipant=>x.PARTICIPANT_ID === itemparticipant.PARTICIPANT_ID &&  x.ASSESMENT_ID === itemparticipant.ASSESMENT_ID)
                                if(checkList.length>0){
                                    return {...x, SCORE :  checkList[0].SCORE}
                                }
                                else{
                                    return x
                                }
                                
                            })
                            console.log('participants', participants)
                            console.log('participantAllAsssesment', _allData)
                            setParticipantAllAssesment(_allData)
                            const _changeAssesmentStatus =  assesments.map(x=>{
                                if(x.ASSESMENT_ID === chooseAssesment.ASSESMENT_ID){
                                    console.log('length',participants, participants.filter(x=>x.SCORE == 0).length)
                                    if( participants.filter(x=>x.SCORE == 0).length > 0 && (participants.length > participants.filter(x=>x.SCORE == 0).length) ){
                                        return {...x, STATUS_EXAM : 'Yellow'}
                                    }
                                    else if(participants.filter(x=>x.SCORE == 0).length == 0){
                                        
                                        return {...x, STATUS_EXAM : 'Red'}
                                    }
                                    else{
                                        return {...x, STATUS_EXAM : 'Green'}
                                    }
                                }
                                else{
                                    return x
                                }
                            })
                            setAssesments(_changeAssesmentStatus)
                        }}>Submit Score</Button>
                        <Box
                            sx={{
                                maxHeight: 500,
                                overflowY: 'auto',     // aktifkan scroll vertikal
                                overflowX: 'hidden',   // matikan scroll horizontal
                                border: '1px solid #ddd',
                                borderRadius: 2,
                                p: 1,
                            }}
                            >
                            <Stack direction="column" spacing={2}>
                                {orderBy(participants, ["FULL_NAME"]).map((item) => (
                                <Box
                                    key={item.PARTICIPANT_ID}
                                    sx={{
                                    width: '97%',
                                    p: 2,
                                    border: '1px solid #ccc',
                                    borderRadius: 2,
                                    backgroundColor: item.BACKCOLOR,
                                    }}
                                >
                                    <Stack spacing={2} direction="row" alignItems="center">
                                         <Box sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'block', xl: 'block'  } }}>
                                            <Avatar
                                                alt="Foto Profil"
                                                src="https://via.placeholder.com/150"
                                                sx={{ width: 80, height: 80 }}
                                            />
                                         </Box>
                                    
                                    <Box>
                                        <Typography variant="h6">{item.FULL_NAME}</Typography>
                                        <Typography variant="body1">Dojo: {item.DOJO_NAME}</Typography>
                                        <FormControl component="fieldset">
                                            <Box sx={{ display: {xs:"block", sm:"block", md:"none", lg:"none", xl:"none"} }}>
                                                <Typography>Score : {item.SCORE}
                                                    <IconButton aria-label="delete" onClick={()=>handleChangeScore("0", item)}>
                                                        <CancelIcon />
                                                    </IconButton>
                                                </Typography>
                                            </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                            <Box sx={{ display: {xs:"none", sm:"none", md:"block", lg:"block", xl:"block"} }}>
                                                <Typography>Score : {item.SCORE}
                                                    <IconButton aria-label="delete" onClick={()=>handleChangeScore("0", item)}>
                                                        <CancelIcon />
                                                    </IconButton>
                                                </Typography>
                                            </Box>
                                            
                                            
                                            <RadioGroup
                                            row
                                            name={`radio-nilai-${item}`}
                                            value={item.SCORE}
                                            onChange={(e)=>handleChangeScore(e.target.value, item)}
                                            >
                                            <FormControlLabel value="20" control={<Radio />} label="KS" />
                                            <FormControlLabel value="40" control={<Radio />} label="K" />
                                            <FormControlLabel value="60" control={<Radio />} label="C" />
                                            <FormControlLabel value="80" control={<Radio />} label="B" />
                                            <FormControlLabel value="100" control={<Radio />} label="BS" />
                                            </RadioGroup>
                                            
                                        </Box>
                                        </FormControl>
                                    </Box>
                                    </Stack>
                                </Box>
                                ))}
                            </Stack>
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </Paper>
    </Container>
  )
}
